export enum WidgetType {
  /** Standalone chat conversation (`clever-search-chat`); also rendered inside the cb/cip/ce hosts. */
  chat = 'chat',
  /** Full page search (`clever-search-fp`): search input, FAQ and result list, no chat shell. */
  fb = 'fb',
  /** Chatbot: floating window with header, opened/closed by the toggler. */
  cb = 'cb',
  /** Chat in page (`clever-search-chat-in-page`): chat with header placed inline in the page. */
  cip = 'cip',
  /** Modern style chatbot: cb variant with the bordered, flat modern theme. */
  cmt = 'cmt',
  /** Transparent style chatbot: cb variant with the translucent glass theme. */
  ctt = 'ctt',
  /** Chat embedded (`clever-search-chat-embedded`): headerless chat embedded inline in the page. */
  ce = 'ce',
}
